// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGDate = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  children: [/*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("path", {
      d: "M3.4 22c-.22 0-.4-.192-.4-.429V9h18v6.898l-.097.103h-4.299c-.884 0-1.6.768-1.6 1.715v4.18l-.097.104H3.4zM17.923 3.31V1.241c0-.686-.569-1.241-1.27-1.241-.7 0-1.268.555-1.268 1.241v2.07h-6.77V1.24C8.615.555 8.047 0 7.346 0c-.7 0-1.27.555-1.27 1.241v2.07H3.963C2.328 3.31 1 4.61 1 6.206v14.896C1 22.701 2.328 24 3.962 24h11.846c.336 0 .659-.13.897-.363l5.924-5.793c.237-.234.371-.55.371-.878V6.206c0-1.596-1.328-2.896-2.962-2.896h-2.115zM8 11H6c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1h2c.552 0 1-.448 1-1v-2c0-.552-.448-1-1-1m3 0c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1h2c.552 0 1-.448 1-1v-2c0-.552-.448-1-1-1h-2zm5 4h2c.552 0 1-.448 1-1v-2c0-.552-.448-1-1-1h-2c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1m-8 1H6c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1h2c.552 0 1-.448 1-1v-2c0-.552-.448-1-1-1m5 0h-2c-.552 0-1 .448-1 1v2c0 .552.448 1 1 1h2c.552 0 1-.448 1-1v-2c0-.552-.448-1-1-1",
      id: "date__a"
    })
  }), /*#__PURE__*/_jsx("use", {
    xlinkHref: "#date__a",
    fillRule: "evenodd"
  })]
}));
SVGDate.displayName = 'SVGDate';
export default SVGDate;